import { StateInterface } from 'store';
import { useCallback } from 'react';

export const selectStories = (state: StateInterface) => state?.stories;
export const selectStoriesItems = (state: StateInterface) =>
  (selectStories(state)?.items || []).sort((a: any, b: any) => (b?.weight || 0) - (a?.weight || 0));
export const selectStoriesLoading = (state: StateInterface) => selectStories(state)?.loading;
export const selectStoriesError = (state: StateInterface) => selectStories(state)?.error;
export const selectStoriesItemsCount = (state: StateInterface) => selectStoriesItems(state).length;
